import { render, staticRenderFns } from "./Table_ia.vue?vue&type=template&id=11bd3662&scoped=true&"
import script from "./Table_ia.vue?vue&type=script&lang=js&"
export * from "./Table_ia.vue?vue&type=script&lang=js&"
import style0 from "./Table_ia.vue?vue&type=style&index=0&id=11bd3662&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bd3662",
  null
  
)

export default component.exports